<!-- Предупреждение о неуспешной попытке пересчёта без подмены текущего ПЛАНа. -->
<template>
  <div class="plan-attempt-warning">
    <span>
      <strong>Последний пересчёт не выполнен.</strong> {{ error }}
      <span v-if="hasCurrentPlan">Текущий успешный ПЛАН сохранён.</span>
    </span>
    <PlanCalculationSettingsButton
      v-if="canConfigureCalculator && calculatorPresetId"
      :preset-id="calculatorPresetId"
      :calculator-name="calculatorName"
      label="Настроить калькулятор"
    />
  </div>
</template>

<script>
import PlanCalculationSettingsButton from "@/components/Order/PlanCalculation/Buttons/Settings.vue";

export default {
  name: "OrderPlanCalculationAttemptWarning",

  components: { PlanCalculationSettingsButton },

  props: {
    error: { type: String, required: true },
    hasCurrentPlan: { type: Boolean, default: false },
    calculatorPresetId: { type: [String, Number], default: null },
    calculatorName: { type: String, default: "" },
    canConfigureCalculator: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.plan-attempt-warning {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #fef3c7;
  color: #854d0e;
  font-size: 13px;
  line-height: 1.4;
}

@media (max-width: 767px) {
  .plan-attempt-warning {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
